import { render } from "./FileMoveDialog.vue?vue&type=template&id=ddc24548"
import script from "./FileMoveDialog.vue?vue&type=script&lang=js"
export * from "./FileMoveDialog.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/bc49b04f-2ffc-492f-a3c6-ed004d6cdf93/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__